var config =  {
    keyvault_service_client_id: process.env.keyvault_service_client_id,
    keyvault_service_client_secret: process.env.keyvault_client_secret,
    keyvault_service_tenant_id: process.env.keyvault_tenant_id,
    keyvault_url: process.env.keyvault_url,
    cache_lifetime_in_seconds: process.env.cache_lifetime_in_seconds,
    client_cache_timeout_in_seconds: process.env.client_cache_timeout_in_seconds,
    use_identity: process.env.use_identity,
    isDevelopment: process.env.development,
    getLocalConfig: (keyName) => {
        return process.env[keyName];
    }
};
module.exports = config;